// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1fFgi","approved":"Status_approved__2PHOE","rejected":"Status_rejected__2dqxc","expired":"Status_expired__1icml","label":"Status_label__1rivw"};